const LAUNCH_DARKLY_PROJECT_KEY = 'default';

/** Environments shown side by side on the LaunchDarkly targeting page, in pipeline order. */
const LAUNCH_DARKLY_ENVIRONMENT_KEYS = ['test', 'qa', 'uat', 'production'] as const;

/**
 * Build a link to a flag's targeting page in LaunchDarkly, with every environment in view and
 * `selectedEnvironmentKey` focused.
 */
export function launchDarklyFlagUrl(flagKey: string, selectedEnvironmentKey: string): string {
    const params = new URLSearchParams();
    for (const environmentKey of LAUNCH_DARKLY_ENVIRONMENT_KEYS) {
        params.append('env', environmentKey);
    }
    params.set('selected-env', selectedEnvironmentKey);
    return `https://app.launchdarkly.com/projects/${LAUNCH_DARKLY_PROJECT_KEY}/flags/${encodeURIComponent(flagKey)}/targeting?${params}`;
}
